// tslint:disable no-any
import React from "react";
import { Dollar } from '../Icons'
//import { MaskedPhoneInputField } from './MaskedInput'
import { Visible, NonVisible } from '../../Components/Icons'

type ComboBoxOptions = {
  [index: string]: string
}

export interface Props {
  borderColor?: 'default' | 'teal' | 'red' | 'none',
  children?: React.ReactNode,
  errors?: string | boolean,
  helperErrors?: boolean,
  label: string,
  labelColor?: 'default' | 'teal' | 'red' | 'gray',
  disabled: boolean,
  fullWidth?: boolean
  id: string,
  options?: ComboBoxOptions,
  type: string,
  numRows?: number,
  value: string,
  cb?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void,
  required: boolean,
  placeHolder?: string,
  limit?: number
}

export interface State {
  showPassword: boolean
}

export class InputField extends React.PureComponent<Props, State> {

  
  public static defaultProps = {
    helperErrors: false,
  }

  constructor(props: Props) {
    super(props)

    this.state = {
        showPassword: false,
      }  
  }

  public disabled(): string {
    if (this.props.disabled) {
      return 'font-medium text-gray-400 cursor-default'
    }

    return 'font-medium cursor-pointer'
  }

  public render(): React.ReactNode {
    const { type, errors, helperErrors } = this.props
    const input = this.buildInputs(type)

    // In some scenarios (SelfSignupView) we need to show errors inline
    // with the form elements, so explicitly allow that option here.
    if (!errors || helperErrors) {
      return (<React.Fragment>
        {input}
        {this.props.children}
      </React.Fragment>)
    }

    return (
      input
    )
  }

  private buildInputs(type: string) {
    switch (type.toLowerCase()) {
      case 'select':
        return this.getSelections()
      /*case 'tel':
        return this.getPhoneInputField()
        break*/
      case 'autocomplete':
        return this.getAutoComplete()  
      case 'text':
        return this.getTextInputField()
      case 'password':
        return this.getPasswordInputField()
      case 'textarea':
        return this.getTextArea()
      case 'herotext':
        return this.getHero()
      case 'money':
        return this.getMoney()
      default:
        return this.getTextInputField()
    }
  }

  private getBorderColors = () => {
    const { borderColor } = this.props
    let styles = ''

    switch (borderColor) {
      case 'none':
        styles = ''
        break
      case 'teal':
        styles = 'focus-within:border-teal'
        break
      case 'red':
        styles = 'focus-within:border-red-400'
        break
      case 'default':
      default:
        styles = 'focus-within:border-blue-500'
    }

    return styles
  }

  private getLabelColors = () => {
    const { labelColor } = this.props
    let styles = ''

    switch (labelColor) {
      case 'teal':
        styles = 'floatingInputLabelTeal'
        break
      case 'red':
        styles = 'floatingInputLabelError'
        break
      case 'default':
      default:
        styles = 'floatingInputLabelBlue'
    }

    return styles
  }

  private width(): string {
    if (this.props.fullWidth) {
      return 'w-full'
    }

    return 'flex-grow'
  }

  private getTextInputField = () => {
    const data = this.props
    const { disabled } = data

    const { borderStyles } = this.getStyles()

    return (
      <div className='flex flex-col flex-no-wrap sm:flex-row flex-grow'>
        <div className={borderStyles} >
          {disabled ? this.getDisabledInputField() : this.getEditableInputField()}
        </div>
      </div>
    )
  }

  private getPasswordInputField = () => {
   // const data = this.props
    //const { disabled } = data

    const { label, value, required, id, errors } = this.props

    let type = this.state.showPassword ? 'text' : 'password'

    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { labelStyles } = this.getStyles()
    const { borderStyles } = this.getStyles()

    let borderColor = (errors) ? 'border-red-500' : 'border-gray-300'

    let inputStyles = `border ${borderColor} text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 py-2.5 sm:py-3 px-4 pe-9 block w-full border-gray-200 rounded-lg sm:text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500`

    let icon = this.state.showPassword ? (<Visible size='small' className='fill-slate-500'/>) : (<NonVisible size='small' className='fill-slate-500'/>)

    return (
      <div className='flex flex-col flex-no-wrap sm:flex-row flex-grow'>
        <div className={borderStyles} >
          <label className={labelStyles} htmlFor={id}>
          {label}{required ? '*' : ''}
        </label>
        <div className="relative">
      <input type={type}
        value={value}
        onChange={cb}
        id={id} 
        required={required} 
        name='hs-input-with-leading-and-trailing-icon'
        className={inputStyles} 
        placeholder={placeHolder} />
      <div className="absolute inset-y-0 end-0 flex items-center z-200 pe-4">
        <div onClick={() => this.setState({showPassword: !this.state.showPassword})}className="text-gray-500 dark:text-neutral-500 hover:cursor-pointer">
         {icon}
        </div>
      </div>
    </div>

        <div className='w-full flex text-xs text-red-500 my-2 ml-2'>
          {errors}
        </div>
        </div>
      </div>
    )
  }

  /*
  <div class="max-w-sm space-y-3">
  <div>
    <label for="hs-input-with-leading-and-trailing-icon" class="block text-sm font-medium mb-2 dark:text-white">Price</label>
    <div class="relative">
      <input type="text" id="hs-input-with-leading-and-trailing-icon" name="hs-input-with-leading-and-trailing-icon" class="py-2.5 sm:py-3 px-4 ps-9 pe-16 block w-full border-gray-200 rounded-lg sm:text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600" placeholder="0.00">
      <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-4">
        <span class="text-gray-500 dark:text-neutral-500">$</span>
      </div>
      <div class="absolute inset-y-0 end-0 flex items-center pointer-events-none z-20 pe-4">
        <span class="text-gray-500 dark:text-neutral-500">USD</span>
      </div>
    </div>
  </div>
</div>
  */

  private getHero = () => {
    const { value, id, errors } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { borderStyles } = this.getStyles()

    return (
      <div className='w-full flex flex-col flex-no-wrap'>
        <div className='w-full'>
          <div className={borderStyles} >
            <input type="text" id={id}
              onChange={cb}
              value={value}
              className="bg-gray-50 border-b-2 text-gray-900 text-l focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 placeholder:text-gray-500 placeholder:text-center"
              placeholder={`${placeHolder}*`} required />
          </div>
        </div>
        <div className='w-full flex text-xs text-red-500 my-1'>
          {errors}
        </div>
      </div>
    )
  }

  private getMoney = () => {
    const data = this.props
    const { disabled } = data

    const { label, value, required, id, type, errors } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { labelStyles, inputStyles } = this.getStyles()
    const { borderStyles } = this.getStyles()

    return (
      <React.Fragment>
        <label className={labelStyles} htmlFor={id}>
          {label}{required ? '*' : ''}
        </label>
        <div className={borderStyles} >
          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <Dollar
              className='fill-slate-500'
              size='small'
            />
          </div>
          <input
            disabled={disabled}
            className={`${inputStyles} ps-10`}
            id={id} type={type} value={value} onChange={cb} required={required} placeholder={placeHolder}
          />
        </div>
        <div className='w-full flex text-xs text-red-500 my-1'>
          {errors}
        </div>
        </React.Fragment>
    )
  }

  private getEditableInputField = (type?: string) => {
    const { label, value, required, id, errors } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { labelStyles, inputStyles } = this.getStyles()
    const { borderStyles } = this.getStyles()

    return (
      <React.Fragment>
        <label className={labelStyles} htmlFor={id}>
          {label}{required ? '*' : ''}
        </label>
        <div className={borderStyles} >
          <input
            className={inputStyles}
            id={id} type={type} value={value} onChange={cb} required={required} placeholder={placeHolder}
          />
        </div>

        <div className='w-full flex text-xs text-red-500 my-2 ml-2'>
          {errors}
        </div>
      </React.Fragment>

    )
  }

  private getDisabledInputField() {
    const { label, value, required, id, type, errors } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { inputStyles, labelStyles } = this.getStyles()

    return (
      <React.Fragment>
        <label className={labelStyles} htmlFor={id}>
          {label}{required ? '*' : ''}
        </label>
        <input
          className={inputStyles}
          disabled
          id={id} type={type} value={value} onChange={cb} required={required} placeholder={placeHolder}
        />
        <div className='w-full flex text-xs text-red-500 my-1'>
          {errors}
        </div>
      </React.Fragment>
    )
  }

  /*private getPhoneInputField () {
    const { disabled, label, value, required, id, type } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const { inputStyles, labelStyles, borderStyles } = this.getStyles()

    return (
      <div className={`flex flex-col flex-no-wrap sm:flex-row ${this.width()}`}>
        <div className={borderStyles}>
          {<MaskedPhoneInputField
            className={inputStyles}
            disabled={disabled}
            id={id} type={type} value={value} cb={cb} required={required}
          />}
          <label className={labelStyles} htmlFor={id}>
            {label}{required ? '*' : ''}
          </label>
        </div>
      </div>
    )
  }*/;
  private getSelections() {
    const { label, disabled, value, required, id, errors } = this.props
    const options = this.props.options !== undefined ? this.props.options : {}
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : "Select Your Option"
    const { borderStyles } = this.getStyles()

    return (
      <div className='flex flex-col flex-no-wrap sm:flex-row w-full'>
        <div className='w-full relative hover:border-b-1
        focus:outline-none focus-within:border-blue-500 focus-within:border-b-1 relative'>
          <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-gray' htmlFor={id}>
            {label}{required ? '*' : ''}
          </label>
          <div className={borderStyles}>
            <select
              className='w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2'
              onChange={cb} defaultValue="" value={value} id={id} disabled={disabled}>
              <option value="" >{placeHolder}</option>
              {this.buildOptions(options)}
            </select>
          </div>

          <div className='w-full flex text-xs text-red-500 my-1'>
            {errors}
          </div>
        </div>
      </div>
    )
  }

  private getAutoComplete = () => {
    const { label, value, required, id, errors } = this.props
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const options = this.props.options !== undefined ? this.props.options : {}
    const placeHolder = this.props.placeHolder !== undefined ? this.props.placeHolder : ""
    const { labelStyles, inputStyles } = this.getStyles()
    const { borderStyles } = this.getStyles()

    return (
      <React.Fragment>
        <div className={borderStyles} >
           {this.props.disabled ? this.getDisabledInputField() : 
           <div>
             <label className={labelStyles} htmlFor={id}>
          {label}{required ? '*' : ''}
        </label>
        <input
            className={inputStyles}
            id={id} type='text' value={value} list={`${id}_list`} onChange={cb} required={required} placeholder={placeHolder}
          />
            </div>
          }
          <datalist id={`${id}_list`}>
            {this.buildOptions(options)}
          </datalist>
        </div>

        <div className='w-full flex text-xs text-red-500 my-2 ml-2'>
          {errors}
        </div>
      </React.Fragment>
    )
  }

  private getTextArea() {
    const { label, disabled, value, id, errors, limit } = this.props
    const numRows = this.props.numRows !== undefined ? this.props.numRows : 4
    const cb = this.props.cb !== undefined ? this.props.cb : () => null
    const { inputStyles, labelStyles } = this.getStyles()
    const { borderStyles } = this.getStyles()

    let displayValue = (value !== undefined && (limit !== undefined && limit > 0)) ? (limit - value.length) : limit

    return (
      <div className='flex flex-col flex-no-wrap sm:flex-row w-full mb-2'>
        <div className='w-full relative mb-2 md:mb-0 hover:border-b-1
        focus:outline-none focus-within:border-blue-500 focus-within:border-b-1'>
          <label className={labelStyles} htmlFor={id}>
            {label}
          </label>
          <div className={borderStyles}>
            <textarea
              maxLength={limit}
              className={inputStyles}
              disabled={disabled}
              id={id} value={value} onChange={cb} placeholder=' '
              rows={numRows}
            />
          </div>
          <div className="flex flex-col flex-no-wrap">
            {(displayValue !== undefined && Number(displayValue) <= 50) &&
              <div className="text-xs pt-2">
              Characters Remaining: {displayValue}
            </div>
            }
          </div>

          <div className='w-full flex text-xs text-red-500 my-1'>
            {errors}
          </div>
        </div>
      </div>
    )
  }

  private getStyles() {
    const focusBorderColor = this.getBorderColors()
    const labelColor = this.getLabelColors()
    const baseContainer = `${this.width()} relative mb-2 md:mb-0 hover:border-b-1 focus:outline-none`

    const errorContainer = `w-full relative mb-2 md:mb-0 focus:outline-none`

    const disabledContainer = `w-full relative mb-2 md:mb-0 focus:outline-none
    ${focusBorderColor} text-gray-600`

    if (!this.props.errors) {

      const { disabled } = this.props

      return (
        {
          borderStyles: (true !== disabled) ? baseContainer : disabledContainer,
          inputStyles: 'border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5',
          labelStyles: `block mb-2 text-sm font-medium text-gray-500 dark:text-gray ${labelColor} `,
        }
      )
    }

    return (
      {
        borderStyles: errorContainer,
        inputStyles: 'floatingInputError border border-red-500 rounded-lg text-gray-900 w-full p-2.5 focus:outline-non text-sm',
        labelStyles: `block mb-2 text-sm font-medium text-gray-900 dark:text-gray ${labelColor} `,
      }
    )
  }

  /* Accepts object of key: value as props */
  private buildOptions = (opts: ComboBoxOptions) => {

    return (Object.keys(opts)).map(k => {
      return (
        <option key={k} value={k}>{opts[k]}</option>
      )
    })
  }

}

export default InputField
